<template>
    <v-dialog v-model="dialog" max-width="1366px" transition="dialog-transition" persistent>
        <v-toolbar dense dark color="secondary">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">View Order</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card>
            <v-container grid-list-xs fluid>
                <v-row class="mx-5 my-4">
                    <div class="tm">
                        <v-combobox
                            v-model="type"
                            :items="types"
                            class="mt-3"
                            :item-text="'Type'"
                            :item-value="'id'"
                            label="Station Type"
                            auto-select-first
                            hide-details
                            dense
                        ></v-combobox>
                    </div>
                    <div class="tm">
                        <v-text-field
                            v-model="editedItem.OrderID"
                            label="OrderID"
                            disabled
                            hide-details
                            dense
                            class="mx-3"
                        ></v-text-field>
                    </div>
                    <div class="tm">
                        <v-text-field
                            v-model="editedItem.DateOrdered"
                            label="Order Date"
                            class="mx-3"
                            hide-details
                            dense
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="mx-5">
                    <div class="tm">
                        <v-combobox required v-model="editedItem.Station" :items="filteredStations" :item-text="'Name'"
                            :item-value="'id'" label="Station" :rules="[v => !!v || 'Station is required']" class="mx-3"
                            auto-select-first @change="getStationInfo()"></v-combobox>
                    </div>
                    <div class="tm">
                        <v-combobox required v-model="editedItem.Customer" :items="customers" :item-text="'Name'"
                            :item-value="'id'" label="Customer" @change="updateCodes()"
                            :rules="[v => !!v || 'Customer is required ']" class="mx-3" auto-select-first></v-combobox>
                    </div>
                    <div class="tm">
                        <v-combobox required v-model="editedItem.Terminal" :items="terminals" :item-text="'Name'"
                            :item-value="'id'" :rules="[v => !!v || 'Terminal is required']" label="Terminal"
                            @change="updateCodes()" class="mx-3" auto-select-first></v-combobox>
                    </div>
                    <div class="tm">
                        <v-combobox required v-model="editedItem.Supplier" :items="suppliers" :item-text="'Supplier'"
                            :rules="[v => !!v || 'Supplier is required']" :item-value="'id'" label="Supplier"
                            @change="updateCodes()" class="mx-3" auto-select-first></v-combobox>
                    </div>
                </v-row>
                
                <v-row class="mx-5">
                    <div class="tm">
                        <v-text-field
                            class="mx-3"
                            label="Loading Number"
                            v-model="editedItem.LoadingNumber"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="Requested Date"
                            id="DateRequested"
                            :value="editedItem.DateRequested"
                            v-mask="'####/##/## ##:##'"
                            :rules="dateRules"
                            type="tel"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            v-model="editedItem.RetainHrs"
                            id="RetainHrs"
                            v-if="this.type.id != 1"
                            v-mask="'##:##'"
                            label="RetainHrs"
                            class="mx-1"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="ROHrs Date"
                            id="ROHrsDate"
                            v-if="this.type.id != 1"
                            :value="editedItem.ROHrsDate"
                            v-mask="'####-##-##'"
                            class="ml-1"
                            :rules="dateRules"
                            type="tel"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            label="ROHrs Time"
                            id="ROHrsTime"
                            v-if="this.type.id != 1"
                            v-model="editedItem.ROHrsTime"
                            v-mask="'##:##'"
                            class="mx-1"
                        ></v-text-field>
                    </div>
                    <div class="tm12">
                        <v-text-field
                            class="mx-3"
                            label="Created By"
                            v-model="editedItem.Username"
                            disabled
                        ></v-text-field>
                    </div>
                </v-row>
                <v-row class="mx-5">
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.OrderType"
                            :items="order_types"
                            :item-text="'OrderType'"
                            :item-value="'OrderTypeID'"
                            label="Order Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.SplitType"
                            :items="split_types"
                            :item-text="'SplitTypeName'"
                            :item-value="'SplitTypeID'"
                            label="Split Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                    <div class="tm2">
                        <v-combobox
                            v-model="editedItem.NoLoadType"
                            :items="no_load_types"
                            :item-text="'NoLoadTypeName'"
                            :item-value="'NoLoadTypeID'"
                            label="No Load Type"
                            class="mx-3"
                            auto-select-first
                        ></v-combobox>
                    </div>
                </v-row>
                <v-row
                    class="mx-5"
                >
                    <div class="tm65">
                        <v-row>
                            <div class="tm5">
                                <v-textarea
                                    v-model="editedItem.DispatchComments"
                                    label="Dispatch Comments"
                                    class="mx-3"
                                    rows="3"
                                    no-resize
                                ></v-textarea>
                            </div>
                            <div class="tm5">
                                <v-textarea
                                    class="mx-3"
                                    rows="3"
                                    label="Special Instructions"
                                    v-model="editedItem.SpecialInstructions"
                                    no-resize
                                ></v-textarea>
                            </div>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Detail"
                                    v-model="editedItem.ShiftDetail"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Driver"
                                    v-model="editedItem.Driver"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift Date"
                                    v-model="editedItem.ShiftDate"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Trailer"
                                    v-model="editedItem.Trailer"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="mx-3"
                                    label="Shift"
                                    v-model="editedItem.Shift"
                                    disabled
                                ></v-text-field>
                                <v-text-field
                                    class="mx-3"
                                    label="Truck"
                                    v-model="editedItem.Truck"
                                    disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="tm35">
                        <v-data-table
                            :headers="headers"
                            :items="orderProducts"
                            item-key="id"
                            class="elevation-1 ml-2"
                            dense
                            height="200px"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                        >
                            <template v-slot:top>
                                <v-toolbar dark color="secondary" dense>
                                    <v-spacer />
                                    <v-toolbar-title class="white--text"
                                        >Order Detail</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn large icon @click="updateCodes()"
                                        ><v-icon>mdi-reload</v-icon></v-btn
                                    >
                                    <v-btn
                                        :disabled="
                                            editedItem.isSpecific > 0 &&
                                                editedItem.ShiftDetail > 0
                                        "
                                        large
                                        icon
                                        @click="addRow()"
                                        ><v-icon>mdi-plus</v-icon></v-btn
                                    >
                                </v-toolbar>
                            </template>
                            <template v-slot:item.Product="{ item, index }">
                                <v-combobox
                                    v-model="item.Product"
                                    :items="products"
                                    :item-text="'Product'"
                                    :item-value="'ProductID'"
                                    auto-select-first
                                    dense
                                    :disabled="
                                        editedItem.isSpecific > 0 &&
                                            editedItem.ShiftDetail > 0
                                    "
                                    class="pdr"
                                    @change="getCode(item, index)"
                                ></v-combobox>
                            </template>
                            <template v-slot:item.Quantity="{ item }">
                                <v-text-field
                                    v-model="item.Quantity"
                                    :rules="orderRules"
                                    type="number"
                                    dense
                                    class="pdr"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.ProductCode="{ item }">
                                <v-text-field
                                    v-model="item.ProductCode"
                                    dense
                                    class="pdr"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.Delete="{ item }">
                                <v-btn
                                    color="secondary"
                                    icon
                                    dark
                                    :disabled="
                                        editedItem.isSpecific > 0 &&
                                            editedItem.ShiftDetail > 0
                                    "
                                    @click="searchIndex(item)"
                                >
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>
                    <!--Row Order Detail-->
                </v-row>
                <v-row justify="end">
                    <v-col cols="2">
                        <!-- <v-btn color="secondary">Save <v-icon class="ml-2">mdi-content-save</v-icon></v-btn> -->
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from 'moment';
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    props: ['dialog', 'dataInfo', 'OrderInfo'],
    directives: {
        mask
    },
    data: function () {
        return {
            dialog: false,
            orderID: this.$store.state.editedOrder.id,
            today: moment(),
            valid: true,
            Special: 0,
            defaultItem: {
                Station: '',
                Customer: '',
                Terminal: '',
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                onPrice: false,
                SplitApprovedCK: false,
                NoAllocation: false,
                orderProducts: {
                    Product: [],
                    Quantity: []
                },
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: null
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: null
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: null
                }
            },
            headers: [
                { text: 'Product', value: 'Product', width: '50%' },
                { text: 'Product Code', value: 'ProductCode', width: '20%' },
                { text: 'Quantity', value: 'Quantity', width: '20%' },
                { text: 'Delete', value: 'Delete', width: '10%' }
            ],
            editedItem: {
                isSpecific: 0,
                Station: '',
                Customer: '',
                editID: 0,
                Terminal: '',
                Order: [],
                Supplier: '',
                LoadingNumber: '',
                DateRequested: '',
                SpecialInstructions: '',
                DispatchComments: '',
                DateOrdered: '',
                TimeOrdered: '',
                ShiftDetail: '',
                Driver: '',
                Truck: '',
                Trailer: '',
                Shift: '',
                ShiftDate: '',
                Username: '',
                validate: false,
                SplitApprovedCK: false,
                NoAllocation: false,
                ROHrsTime: '',
                RetainHrs: '',
                ROHrsDate: '',
                SplitType: {
                    SplitTypeName: '',
                    SplitTypeID: null
                },
                NoLoadType: {
                    NoLoadTypeName: '',
                    NoLoadTypeID: null
                },
                OrderType: {
                    OrderType: '',
                    OrderTypeID: null
                }
            },
            SBusinessInterruption: false,
            TBusinessInterruption: false,
            Cont: 1,
            orderProducts: [],
            deletedProducts: [],
            types: [
                { id: 1, Type: 'Contracted' },
                { id: 2, Type: 'Private' },
                { id: 3, Type: 'Interplant' }
            ],
            type: [],
            stations: [],
            customers: [],
            terminals: [],
            suppliers: [],
            split_types: [],
            no_load_types: [],
            order_types: [],
            rows: [0],
            rowCount: 0,
            products: [],
            orderRules: [
                v => !!v || 'This field is required',
                v => (v && v <= 60000) || 'Amount should not be above 60,000'
            ],
            menu: false,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },
    
    computed: {
        orderTot() {
            return this.orderProducts.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        },
        filteredStations() {
            return this.stations.filter(i => {
                return !this.type || i.StationType == this.type.id;
            });
        }
    },
    mounted() {
        console.log(this.OrderInfo);
        this.loadStations();
        this.loadCustomers();
        this.loadTerminals();
        this.loadSuppliers();
        this.loadInfo();
    },
    methods: {
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/active')
                .then(response => {
                    this.stations = response.data.data;
                    const idx =  this.stations.findIndex(x => {
                        return x.id == this.OrderInfo.Station;
                    });
                    this.editedItem.Station = this.stations[idx];
                    console.log(this.stations,idx);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    this.customers = response.data.data;
                    const idx =  this.customers.findIndex(x => {
                        return x.id == this.OrderInfo.Customer;
                    });
                    this.editedItem.Customer = this.customers[idx];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function() {
            this.$store.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                    const idx =  this.terminals.findIndex(x => {
                        return x.id == this.OrderInfo.Terminal;
                    });
                    this.editedItem.Terminal = this.terminals[idx];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active')
                .then(response => {
                    this.suppliers = response.data.data;
                    const idx =  this.suppliers.findIndex(x => {
                        return x.id == this.OrderInfo.Supplier;
                    });
                    this.editedItem.Supplier = this.suppliers[idx];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadInfo: function (){
            this.editedItem.OrderID = this.OrderInfo.OrderID;
            this.editedItem.ROHrsDate = this.OrderInfo.ROHrsDate;
            this.editedItem.ROHrsTime = this.OrderInfo.ROHrsTime;
            this.editedItem.DateRequested = this.OrderInfo.DateRequested;
            this.editedItem.RetainHrs = this.OrderInfo.RetainHrs;
            
            for (const i in this.OrderInfo.order_details) {
                var product = {
                    ProductID:this.OrderInfo.order_details[i].ProductID,
                    Product: this.OrderInfo.order_details[i].product.Product,
                    productDetailID:this.OrderInfo.order_details[i].id,
                    Quantity: this.OrderInfo.order_details[i].ProductQuantity,
                    SpecificTrailerOnly:this.OrderInfo.order_details[i].SpecificTrailerOnly,
                    ProductCode:this.OrderInfo.order_details[i].ProductCode
                };

                this.orderProducts.push(product);
            }
            
            var idx = this.types.findIndex(x => {
                return x.id == this.OrderInfo.station.StationType;
            });
            console.log(idx);
            this.type = this.types[idx];
        }
    }
};
</script>
